import { mutator } from 'satcheljs';
import { default as updateAccount } from '../actions/updateAccount';
import getAccountSourceListStore from '../store/accountSourceListStore';
import { updateMailboxInfo } from '../utils/updateMailboxInfo';

/**
 * Update the specified AccountSource in the store
 */
export default mutator(updateAccount, actionMessage => {
    const store = getAccountSourceListStore();
    store.sources = store.sources.map(accountSource => {
        if (accountSource.sourceId === actionMessage.accountSource.sourceId) {
            updateMailboxInfo(actionMessage.accountSource);
            return actionMessage.accountSource;
        }

        return accountSource;
    });
});
